module.exports = {
  "id": "c8470b9d-2cef-4910-a3e4-4e65dd10900e",
  "gtmIds": [
    "GTM-PXNW7WQW",
    "GTM-KM3WTN8G"
  ],
  "startTracking": "since_launch",
  "hasInAppVersion": true,
  "group": "TVGD",
  "language": "fr-FR",
  "defaultDateFormat": "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL",
  "defaultNumberFormat": null,
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "fr-FR",
    "en-US",
    "de-DE"
  ],
  "website": "https://www.tvgd.ch",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}